export enum userSections {
    ASSETS = "ASSETS",
    CLAIM = "CLAIM"
}